module.exports = __webpack_public_path__ + "static/media/delete-icon.ae18d192.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete-icon.svg
// module id = 1164
// module chunks = 0